<template>
  <v-card class="overflow-hidden v-card v-sheet theme--light mt-0">
    <loading :active.sync="isLoading" 
      :can-cancel="true" 
      :is-full-page="fullPage" :color="primary_code" />
    <!-- Header-->
    <!-- <header-component :headerTitle="headerText" /> -->
    <header-component class="mx-2"
      :headerTitle="headerText"
      :router-link="getRouterLink()"
      :router-link-text="getRouterLinkText()"
      :component-name="componentsName()"
    />
    <v-row justify="center">
      <v-dialog v-model="date_selection_popup" persistent max-width="400px">
        <v-card class="v-card-100">
          <v-row class=" mx-4 pt-4">
            <v-spacer />
            <v-icon @click="date_selection_popup = false">mdi-close</v-icon>
          </v-row>

          <div class="text-center">
            <v-icon color="error" size="40">mdi-information-outline</v-icon>
          </div>
          <div class="text-center mt-6">Selection of atleast one date field is mandatory</div>
          <div class="text-center pb-9" style="text-decoration: underline;color: #0275d8;cursor: pointer;" @click="updateToDateField">Check Date Field</div>
        </v-card>
      </v-dialog>
    </v-row>


    <v-row justify="center">
      <v-dialog v-model="add_new_field_popup" persistent max-width="800px">
        <v-card class="v-card-100">
          <v-card-title class="pa-3">
            <v-card class="mt-0 mb-2 v-card-100">
              <v-row class="ma-1">
                <span>{{ new_field_status }}</span>
                <v-spacer />
                <v-icon @click="add_new_field_popup = false">mdi-close</v-icon>
              </v-row>
            </v-card>
          </v-card-title>
          <v-card-text class="mx-3">
            <v-row>
              <v-col>
                <v-text-field v-model="entered_field_name" label="Enter Field Name" variant="outlined" />
              </v-col>
              <v-col>
                <v-autocomplete v-model="selected_field" :items="template_column_list" item-title="value" item-value="key" label="Select Field Name" variant="outlined" @update:model-value="updateCustomHeading"/>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="4">
                <v-btn color="#0357D0" class="ml-2 text-none" style="max-width:170px;" @click="add_to_query">{{ add_field_query_status }}</v-btn>
                <div style="color: #0357D0;font-weight: 400;font-size: 10px; margin-left: 12px;margin-top: 8px;">Click this button to {{ add_field_query_status == 'Start Query' ? 'start a Query' : 'end this Query' }} </div>
              </v-col>
              <v-col cols="12" md="8">
                <v-textarea v-model="query" class="mt-2" variant = "outlined" :readonly="!canAddManualEntry  || add_field_query_status == 'Start Query'" @input="new_field_query_input"></v-textarea>
              </v-col>
            </v-row>
            <span style="font-size: 16px; font-weight: 600;margin-bottom: 16px;">Operators</span>
            <v-row class="mt-2">
              <v-col v-for="operator in operators" :key="operator" cols="auto">
                <span variant="outlined" class="text-none operator_btn" @click="appendToQuery(operator)">{{ operator }}</span>
              </v-col>
              <v-col>
                <span style="color: #0357D0;border-color:#0357D0;" class="text-none operator_btn" cols="3" @click="enterManually">Enter Manually</span>
              </v-col>
              <v-col cols="1">
                <span style="color: #0357D0;border-color:#0357D0;" class="ml-2 operator_btn" @click="clearQuery">
                  <v-icon color="#0357D0">mdi-backspace-outline</v-icon>
                </span>
              </v-col>
            </v-row>
          </v-card-text>
          <v-row>
            <v-spacer />
            <v-btn color="primary" variant="outlined" class="text-none mr-3" @click="add_new_field_popup = false">Cancel</v-btn>
            <v-btn color="primary" variant="flat" class="text-none mr-3" @click="submit_new_add_query" :disabled="add_field_query_status == 'End Query' || !this.query">Submit</v-btn>
            <v-spacer />
          </v-row>
        </v-card>
      </v-dialog>
    </v-row>



    <v-row class="mx-1">
      <v-col>
        <p class="sub_heading text-left mb-2">Schema</p>
        <v-autocomplete v-model="selected_schema" :items="schema_items" class="text-left" placeholder="Select Schema" variant="outlined" @update:modelValue="getItemDetailOptions" :disabled="clone_key === 'Clone'" />
      </v-col>
      <v-col>
        <p v-if="selected_schema" class="sub_heading text-left mb-2">Template Name</p>
        <v-text-field v-if="selected_schema" v-model="selected_template" placeholder="Select Template" variant="outlined" />
      </v-col>
      <v-col>
        <p v-if="selected_schema" class="sub_heading text-left mb-2">Report Type</p>
        <v-autocomplete v-if="selected_schema" v-model="selected_report" class="text-left" :items="report_type_items" placeholder="Select Report Type" variant="outlined" item-text="name" item-value="name" @update:modelValue="reportTypeChange" :disabled="clone_key === 'Clone'" />
      </v-col>
    </v-row>

    <v-row class="selected_detail_popup ml-2 mr-4 mt-0" style="overflow: hidden;" v-if="selected_schema && selected_report">
      <v-col style="border-right: 1px solid #E2E3ED; margin-bottom: -44px;" cols="5">
        <p class="sub_heading text-left" style="line-height: 22.4px !important;">Item Info Detail's</p>
        <v-text-field variant="outlined" v-model="search_details" prepend-inner-icon="mdi-magnify" label="Search" hide-details class="mb-3" style="max-width: 70%;"/>
        <div class="overflow-y-auto text-left overflow-x-hidden" :style="{height : content_height1}">
          <div v-for="(item,index) in item_info_details" :key="index" class="mt-3 ml-4">
            <span :class="selected_details.includes(item) ? 'selected_deatils_option details_option' : 'details_option'"
              @click="update_selected_details(item)"
            >{{ item.value }}</span>
          </div>
        </div>
        <div class="chevron_icon" @click="moveItemToSelectedColumn"><v-icon style="border: 1px solid;border-radius: 14px;">mdi-chevron-double-right</v-icon></div>
      </v-col>
      <v-col cols="7">
        <div class="overflow-y-auto text-left overflow-x-hidden" :style="{height : content_height2}">
          <p class="sub_heading text-left pl-8 py-2" style="line-height: 22.4px !important;" v-if="selected_report != 'Detailed'">Summary</p>
          <v-row class="mr-4" v-if="selected_report != 'Detailed'">
            <v-col cols="8" style="height: 300px; overflow-y: auto;">
              <v-row v-for="(item,index) in confirm_summary_details" :key="index" class="ml-4">
                <v-col cols="4" class="py-1">
                  <p class="sub_heading text-left pl-8 py-2" style="line-height: 22.4px !important;" v-if="!index">Summary</p>
                  <div class="selected_deatils_option details_option mt-4 py-1 d-flex">
                    <div :draggable="selected_report == 'Summary' || selected_report == 'Hybrid'" @dragstart="startDrag($event, item)" style="width: 80%;">{{ item.backend_heading }}</div>
                    <div class="d-flex align-center">
                      <v-icon class="float-right" color="error" @click="removeSelectedColumn(item,'summary')">mdi-minus-circle-outline</v-icon>
                    </div>
                  </div>
                </v-col> 
                <v-col cols="4" class="py-1">
                  <p class="sub_heading text-left pl-8 py-2" style="line-height: 22.4px !important;" v-if="!index">Heading</p>
                  <v-text-field v-model="item.value" hide-details variant="underlined"/>
                </v-col> 
                <v-col cols="4" class="py-1 d-flex" style="align-items: flex-end;">
                  <span class="link_css mb-3" v-if="item.is_query" @click="editQuery(item)">{{ item.query ? "Edit Query" : "Add Query"}}</span>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="4" class="pa-0 my-4">

                <!-- Target Areas -->
                <div class="target-areas" v-if="(selected_report == 'Summary' || selected_report == 'Hybrid') && confirm_summary_details.length">
                  <div class="area">
                    <div class="pl-2 pt-2" style="border: 1px solid #E2E3ED; border-bottom: 0px;">Rows</div>
                    <div
                      class="drop-zone"
                      @drop="onDrop($event, 'rows')"
                      @dragover.prevent
                      @dragenter.prevent
                    >
                      <div v-for="(row_field, index) in rowsField" :key="row_field">
                        {{ row_field.value }}
                        <button @click="removeField('rows',index)">×</button>
                      </div>
                    </div>
                  </div>

                  <div class="area">
                    <div class="pl-2 pt-2" style="border: 1px solid #E2E3ED; border-bottom: 0px;">Columns</div>
                    <div
                      class="drop-zone"
                      @drop="onDrop($event, 'columns')"
                      @dragover.prevent
                      @dragenter.prevent
                    >
                      <div v-for="(column_field, index) in columnsField" :key="column_field">
                        {{ column_field.value }}
                        <button @click="removeField('columns',index)">×</button>
                      </div>
                    </div>
                  </div>
                </div>
            </v-col>
          </v-row>
          <p class="sub_heading text-left pl-8 py-2 mt-3" v-if="selected_report != 'Summary' && ((confirm_detailed_details.length || confirm_summary_details.length) || selected_report == 'Detailed')" style="line-height: 22.4px !important;">Detailed</p>
          <v-row class="mr-4" v-if="selected_report != 'Summary'" style="max-height: 300px; overflow-y: auto;"> 
            <v-col cols="10">
              <v-row v-for="(item,index) in confirm_detailed_details" :key="index" class="ml-4">
                <v-col cols="4" class="py-1">
                  <p class="sub_heading text-left pl-8 py-2" style="line-height: 22.4px !important;" v-if="!index">Detailed</p>
                  <div class="selected_deatils_option details_option mt-4 py-1 d-flex">
                    <div style="width: 80%;">{{ item.backend_heading }}</div>
                    <div class="d-flex align-center">
                      <v-icon class="float-right" color="error" @click="removeSelectedColumn(item, 'detailed')">mdi-minus-circle-outline</v-icon>
                    </div>
                  </div>
                </v-col> 
                <v-col cols="4" class="py-1">
                  <p class="sub_heading text-left pl-8 py-2" style="line-height: 22.4px !important;" v-if="!index">Heading</p>
                  <v-text-field v-model="item.value" hide-details variant="underlined"/>
                </v-col> 
                <v-col cols="4" class="py-1">
                  <span class="link_css d-flex align-center" style="height: 100%;" v-if="item.query" @click="editQuery(item)">Edit Query</span>
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <div v-if="confirm_detailed_details.length || confirm_summary_details.length">
            <v-row>
              <v-col cols="4" class="d-flex flex-column">
                <span class="link_css text-none ml-3 mb-2" @click="addField">Add New Field</span>
                <div class="d-flex">
                  <v-btn color="#0357D0" class="ml-2 text-none" style="max-width:170px;" @click="globalQuery">{{ global_query_status }}</v-btn>
                  <v-tooltip width="500" location="top start">
                    <template v-slot:activator="{ props }">
                      <v-icon v-bind="props" color="primary" size="25" style="Cursor:pointer;margin-left: 8px;margin-top: 4px;">mdi-help-circle-outline</v-icon>
                    </template>
                    <div  class="px-5 py-4" style="background: #ffffff;color:#000000;margin: -10px -16px;border-radius: 6px;box-shadow: 4px 4px 4px 4px rgba(0, 0, 0, 0.1);font-weight:500;">
                      <v-row v-for="(item, index) in query_suggestions" :key="index" class="py-0">
                        <v-col cols="3" class="py-1"><strong>{{ item.keyword }}</strong></v-col>
                        <v-col cols="9" class="py-1">{{ item.example }}</v-col>
                      </v-row>
                    </div>
                  </v-tooltip>
                </div>
                <span style="color: #0357D0;font-weight: 400;font-size: 10px; margin-left: 12px;margin-top: 8px;">Click this button to start a Query</span>
              </v-col>
              <v-col cols="8">
                <v-btn class="text-none" variant = "outlined" color="#0357D0" v-if="selected_report == 'Hybrid'" @click="updateHybridAction">{{ `Add ${ hybrid_action == 'Detailed' ? 'Summary' : 'Detailed'} Fields` }}</v-btn>
                <v-textarea v-model="global_query" style="max-height: 150px;" class="mt-2" variant = "outlined" :readonly="!canAddGloablManualEntry || global_query_status == 'Start Query'" @input="global_query_input"></v-textarea>
              </v-col>
            </v-row>
            <v-row class="mx-5">
              <span style="font-size: 16px; font-weight: 600;">Operators</span>
              <v-row class="mt-2">
                <v-col v-for="operator in operators" :key="operator" cols="auto">
                  <span variant="outlined" class="text-none operator_btn" @click="appendToGlobalQuery(operator)">{{ operator }}</span>
                </v-col>
                <v-col cols="auto">
                  <span  style="color: #0357D0;border-color:#0357D0;" class="text-none operator_btn" @click="enterGloabalManually">Enter Manually</span>
                </v-col>
                <v-col cols="1">
                  <span style="color: #0357D0;border-color:#0357D0;" class="ml-2 operator_btn" @click="clearGloabalQuery">
                    <v-icon color="#0357D0">mdi-backspace-outline</v-icon>
                  </span>
                </v-col>
              </v-row>
            </v-row>
          </div>
        </div>
      </v-col>
    </v-row>


    <v-row class="mt-2 mr-1 py-4" v-if="template_column_list.length && selected_report">
      <v-spacer/>
      <v-btn color="primary" size="x-large" variant="outlined" class="text-none mr-3" @click="cancelTemplate">Cancel</v-btn>
      <v-btn color="primary" size="x-large" variant="outlined" class="text-none mr-3" @click="downloadSample">Download Sample</v-btn>
      <v-btn color="primary" size="x-large" variant="flat" class="text-none mr-3" :disabled="checkSubmitButtonDisabled" @click="submitTemplate">Submit</v-btn>
    </v-row>

  </v-card>
</template>
<script>
  import { readonly } from "vue";
import HeaderComponent from "../../../commoncomponents/HeaderComponent.vue";
  import Loading from 'vue-loading-overlay';
  export default {
  data() {
    return {
      headerText: "Report Creator",
      isLoading: false,
      fullPage: true,
      primary_code: "#0275d8",
      selected_schema: null,
      selected_template: null,
      selected_report: null, 
      schema_items:  [],
      report_type_items: ["Detailed","Summary","Hybrid"],
      content_height1: '',
      content_height2: '',
      search_details : '',
      selected_date_columns : [],
      date_selection_popup : false,
      is_showing_date_field : false,
      selected_details : [],
      confirm_summary_details: [],
      confirm_detailed_details: [],
      selected_summary_details: [],
      selected_detailed_details: [],
      date_column_list : [],
      template_column_list:[],
      query: "",
      add_new_field_popup: false,
      operators: [
        "+", "-", "×", "÷", "=", "<", "≠", "≤", "<", ">", "(", ")",",","IF", "THEN", "BETWEEN",
        "IN", "AND", "OR", "ANY", "ALL", "Contain", "Does Not Contain", "Avg", "Sum", "Count", "Concat", "Mean", "Min", "Max"
      ],
      dependent_operators: ["+", "-", "×", "÷", "=", "<", "≠", "≤", "<", ">","BETWEEN", "IN","Contain", "Does Not Contain"],
      entered_field_name: '',
      selected_field : null,
      next_charecter : '',
      next_global_charecter: '',
      last_global_charecter: '',
      last_charecter: '',
      add_field_query_status: 'Start Query',
      new_field_status: 'Add New Field',
      last_edited_item: {},
      global_query_status: 'Start Query',
      global_query : '',
      global_condition: [],
      enter_global_manually: false,
      enter_field_manually: false,
      summary_id: 1,
      new_field_condition: [],
      rowsField: [],
      columnsField: [],
      hybrid_action: 'Summary',
      template_action: '',
      mapped_key: {},
      clone_key: '',
      query_suggestions : [
        { keyword: 'IF / THEN', example: "CASE WHEN condition THEN result END" },
        { keyword: 'IN', example: "column IN ('value1', 'value2', 'value3')" },
        { keyword: 'BETWEEN', example: "column BETWEEN 'value1' AND 'value2'" },
        { keyword: 'ANY', example: "column > ANY (SELECT value FROM table)" },
        { keyword: 'ALL', example: "column = ALL (SELECT value FROM table)" },
        { keyword: 'CONTAIN', example: "column LIKE '%value%'" },
        { keyword: 'DOES NOT CONTAIN', example: "column NOT LIKE '%value%'" },
        { keyword: 'AVG', example: "AVG(column)" },
        { keyword: 'SUM', example: "SUM(column)" },
        { keyword: 'COUNT', example: "COUNT(column)" },
        { keyword: 'CONCAT', example: "CONCAT(column1, ' ', column2)" },
        { keyword: 'MEAN', example: "AVG(column)" },
        { keyword: 'MIN', example: "MIN(column)" },
        { keyword: 'MAX', example: "MAX(column)" },
      ]
    }
  },
  components: {
    HeaderComponent,Loading
  },
  mounted() {
    this.calculateTableHeight();
    window.addEventListener('resize', this.calculateTableHeight);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.calculateTableHeight);
  },
  created(){
    this.clone_key = this.$store.state.lotIds.clone
    this.getReportSchema()
    this.template_action = this.$store.state.action
    if(this.template_action == 'Edit Template')
      this.updateEditdata()
  },
  computed: {
    item_info_details(){
      return this.is_showing_date_field? this.date_column_list.filter(item => item.toLowerCase().includes(this.search_details.toLowerCase())) : 
            this.template_column_list.filter(item => item.value.toLowerCase().includes(this.search_details.toLowerCase()))
    }, 
    canAddManualEntry() {
      return this.enter_field_manually;
    },
    canAddGloablManualEntry() {
      return this.enter_global_manually;
    },
    checkSubmitButtonDisabled() {
      return this.global_query_status == 'End Query' || !this.selected_template || (this.selected_report == 'Detailed' && !this.confirm_detailed_details.length)
              || (this.selected_report == 'Summary' && !this.confirm_summary_details.length) || (this.selected_report == 'Hybrid' && !this.confirm_summary_details.length && !this.confirm_detailed_details.length)
    }
  },
  methods: {
    getRouterLink() {
      return { name: "reportBuilder" };
    },
    componentsName() {
      return this.clone_key === "Clone" ? "Cloned Template" : this.$store.state.action;
    },
    getRouterLinkText() {
      return this.$store.state.inventoryId;
    },
    calculateTableHeight() {
      const viewportHeight = window.innerHeight;
      const additionalSpace = 439;
      const additionalSpace1 = 252;
      const height = viewportHeight  - additionalSpace;
      this.content_height1 = (height)+ 'px';
      this.content_height2 = (height + 66) + 'px';
    },
    getReportSchema(){
      this.isLoading = true
      this.$httpSecured
      .get("/api/v2/report_builders/get_report_schemas")
      .then(response => {
        this.isLoading = false
        this.schema_items = response.data.schemas
      })
      .catch(error => {
        this.isLoading = false
        this.$toast.error(error.response.data.message);
      });
    },
    updateToDateField(){
      this.date_selection_popup = false
      this.is_showing_date_field = true
    },
    canAddField(){
      return this.new_field_condition.length === 0 || (this.new_field_condition.length > 0 && this.isOperator(this.new_field_condition[this.new_field_condition.length - 1]));
    },
    canAddOperator(operator) {
      return (this.new_field_condition.length && 
              (this.isField(this.new_field_condition[this.new_field_condition.length - 1]) || this.isManualEntry(this.new_field_condition[this.new_field_condition.length - 1]))) 
        || !this.dependent_operators.includes(operator) 
    },
    canAddGlobalField(){
      return this.global_condition.length === 0 || (this.global_condition.length > 0 && this.isOperator(this.global_condition[this.global_condition.length - 1]));
    },
    canAddGlobalOperator(operator) {
      return (this.global_condition.length && (this.isField(this.global_condition[this.global_condition.length - 1]) || this.isManualEntry(this.global_condition[this.global_condition.length - 1]))) || !this.dependent_operators.includes(operator);
    },
    isField(value) {
      return this.template_column_list.map(item => item.value).includes(value);
    },
    isOperator(value) {
      return this.operators.includes(value);
    },
    isManualEntry(value) {
      return !this.isField(value) && !this.isOperator(value);
    },
    update_selected_details(item){
      if(this.global_query_status == 'End Query'){
        if(this.canAddGlobalField()){
          this.next_global_charecter = 'operator'
          this.last_global_charecter = 'field'
          this.global_query += ` ${item.key} `
          this.global_condition.push(item.key)
        }  
        return
      }
      const index = this.selected_details.indexOf(item)
      if(index != -1)
        this.selected_details.splice(index,1)
      else this.selected_details.push(item)
    },
    moveItemToSelectedColumn(){
      if(this.selected_report == 'Detailed' || (this.selected_report == 'Hybrid' && this.hybrid_action == 'Detailed')){
        this.selected_detailed_details = this.selected_details.map(item => item)
        const new_item = this.selected_details.filter(item => !this.confirm_detailed_details.some(detail => detail.key == item.key))
        this.confirm_detailed_details = this.confirm_detailed_details.filter(item => this.selected_details.some(detail => detail.key == item.key) || item.query)
        new_item.forEach(item=> {
          this.confirm_detailed_details.push({ key: item.key, backend_heading: this.mapped_key[item.key], value: item.value})
        })
      } else {
        this.selected_summary_details = this.selected_details.map(item => item)
        const new_item = this.selected_details.filter(item => !this.confirm_summary_details.some(detail => detail.key == item.key))
        this.confirm_summary_details = this.confirm_summary_details.filter(item => this.selected_details.some(detail => detail.key == item.key) || item.query)
        new_item.forEach(item=> {
          if(item.data_type == 'Number' || item.data_type == 'Date')
            this.confirm_summary_details.push({ key: item.key, backend_heading: this.mapped_key[item.key], value: item.value, query: '', is_query: true, summary_id: this.summary_id++})
          else
            this.confirm_summary_details.push({ key: item.key, backend_heading: this.mapped_key[item.key], value: item.value, summary_id: this.summary_id++})
        })
      }
    },
    reliance_global_key_change(text){
      const replacements = [
        [/\bSub-Location\b|\bSub Location\b/g, 'Bin Location'],
        [/\bSublocations\b|\bSub-Locations\b/g, 'Bin Locations'],
        [/\bArticle Id\b|\bArticle ID\b/g, 'Article Code'],
        [/\bScan Indicator\b/g, 'Serial Profile'],
        [/\bASP\b/g, 'RRP'],
        [/\bCategory Code\b/g, 'MCH Code'],
        [/\bCategory L1\b|\bCategory Node 1\b/g, 'Segment'],
        [/\bCategory L2\b|\bCategory Node 2\b/g, 'Class'],
        [/\bCategory L3\b|\bCategory Node 3\b/g, 'Family'],
        [/\bCategory L4\b|\bCategory Node 4\b/g, 'Description'],
        [/\bSerial Number 1\b|\bSerial No.1\b|\bS No. 1\b/g, 'Box Serial Number'],
        [/\bPurchase Vendor\b/g, 'Vendor'],
        [/\bPurchase Location\b/g, 'Receiving DC'],
        [/\bReturn Reason\b/g, 'Nature Of Problem'],
        [/\bReturn Sub-Reason\b/g, 'Type Of Defect'],
        [/\bReturn Request Type\b/g, 'Return Type'],
        [/\bSerial Number 2\b|\bSerial No.2\b|\bS No. 2\b/g, 'Product Serial Number'],
        [/\bComplete IRD\b/g, 'Save Scanned Item'],
        [/\bInwarded Date\b/g, 'Scanned Date'],
      ];
      for (const [regex, replacement] of replacements) {
        text = text.replace(regex, replacement);
      }
      return text
    },
    async getItemDetailOptions(params) {
      this.confirm_detailed_details = [];
      this.confirm_summary_details = [];
      this.selected_summary_details = [];
      this.selected_detailed_details = [];
      this.selected_details = [];
      this.isLoading = true;
      this.mapped_key = {}
      this.summary_id = 1
      try {
        const response = await this.$httpSecured.get(
          `/api/v2/report_builders/get_table_columns?table_name=${this.selected_schema}`
        );
        this.isLoading = false;
        var columns = response.data.columns;
        var date_columns = response.data.date_columns;
        if(this.$store.state.organization_name == 'Reliance'){
          columns = {}
          date_columns = {}
          for (let field in response.data.columns){
            const new_key = this.reliance_global_key_change(field)
            columns[new_key] = response.data.columns[field]
          }
          for (let field in response.data.date_columns){
            const new_key = this.reliance_global_key_change(field)
            date_columns[new_key] = response.data.date_columns[field]
          }
        }
        this.template_column_list = [];
        for (let field in columns) {
          const value = columns[field];
          this.mapped_key[value[0]] = field;
          this.template_column_list.push({ key: value[0], value: field, data_type: value[1] });
        }
        this.date_column_list = date_columns;
        if (typeof params == "object") {
          if (params.columns && params.columns.length > 0) {
            this.date_column_list = params.columns.filter(item => this.date_column_list.includes(item));
          } else {
            this.date_column_list = params.column_names.filter(item => this.date_column_list.includes(item));
          }
        }
        return new Promise(resolve => setTimeout(resolve, 100));
      } catch (error) {
        this.isLoading = false;
        this.$toast.error(error.response?.data?.message || "Error occurred");
        return new Promise(resolve => setTimeout(resolve, 100));
      }
    },
    removeSelectedColumn(item, action){
      if(action == 'detailed'){
        this.confirm_detailed_details = this.confirm_detailed_details.filter(detail => detail.key != item.key)
        this.selected_details = this.selected_details.filter(detail => detail.key != item.key)
        this.selected_detailed_details = this.selected_detailed_details.filter(detail => detail.key != item.key)
      } else {
        this.confirm_summary_details = this.confirm_summary_details.filter(detail => detail.key != item.key)
        this.selected_details = this.selected_details.filter(detail => detail.key != item.key)
        this.selected_summary_details = this.selected_summary_details.filter(detail => detail.key != item.key)
        this.rowsField = this.rowsField.filter(detail => detail.key != item.key)
        this.columnsField = this.columnsField.filter(detail => detail.key != item.key)
      }
    },
    appendToQuery(operator) {
      if(this.add_field_query_status != 'End Query')
        return
      if(this.canAddOperator(operator)){
        const bracket_operators = ['Avg', 'Sum','Count', 'Concat', 'Mean', 'Min', 'Max', 'IN']
        this.query += ` ${this.correctSqlOperator(operator)}${bracket_operators.includes(operator) ? '( ' : ' '}`;
        this.new_field_condition.push(operator)
        this.next_charecter = 'field'
        this.last_charecter = 'operator'
      }
    },
    correctSqlOperator(operator){
      if(operator == '≤') return '<='
      else if(operator == '≥') return '>='
      else if(operator == '≠') return '!='
      else if(operator == 'Contain') return 'Like'
      else if(operator == 'Does Not Contain') return 'Not Like'
      else return operator
    },
    appendToGlobalQuery(operator){
      if(this.global_query_status != 'End Query')
        return
      if(this.canAddGlobalOperator(operator)){
        const bracket_operators = ['Avg', 'Sum','Count', 'Concat', 'Mean', 'Min', 'Max', 'IN']
        this.global_query += ` ${this.correctSqlOperator(operator)}${bracket_operators.includes(operator) ? '( ' : ' '}`;
        this.global_condition.push(operator)
        this.next_global_charecter = 'field'
        this.last_global_charecter = 'operator'
      }
    },
    enterManually() {
      if(this.add_field_query_status != 'End Query')
        return
      this.last_charecter = this.next_charecter
      this.next_charecter = 'manual'
      this.query += "'"
      this.enter_field_manually = true
    },
    enterGloabalManually() {
      if(this.global_query_status != 'End Query')
        return
      this.last_global_charecter = this.next_global_charecter
      this.next_global_charecter = 'manual'
      this.global_query += "'"
      this.enter_global_manually = true
    },
    clearQuery() {
      if(this.add_field_query_status != 'End Query')
        return
      const n = this.query[this.query.length - 1] == ' ' ? -2 : -1 
      this.new_field_condition.pop()
      this.query = this.query.split(' ').slice(0, n).join(' ')
    },
    clearGloabalQuery() {
      if(this.global_query_status != 'End Query')
        return
      const n = this.global_query[this.global_query.length - 1] == ' ' ? -2 : -1 
      this.global_condition.pop()
      this.global_query = this.global_query.split(' ').slice(0, n).join(' ')
    },
    addField() {
      this.new_field_status = 'Add New Field'
      this.add_new_field_popup = true
      this.query = ''
      this.entered_field_name = ''
      this.new_field_condition = []
      this.add_field_query_status = 'Start Query'
    },
    add_to_query(){
      if(this.add_field_query_status == 'Start Query'){
        this.query += ''
        this.next_charecter = 'operator'
        this.last_charecter = 'field'
        this.add_field_query_status = 'End Query'
      } else if(this.add_field_query_status == 'Edit Query'){
        this.add_field_query_status = 'End Query'
      }else{
        this.add_field_query_status = 'Edit Query'
      }
    },
    getFieldKey(name){
      return name.replace(/[^a-zA-Z0-9]+/g, '_').replace(/_+/g, '_').replace(/^_+|_+$/g, '').toLowerCase()
    },
    submit_new_add_query(){
      if(this.new_field_status == 'Edit Field'){
        this.last_edited_item.key = this.getFieldKey(this.entered_field_name)
        this.last_edited_item.value = this.entered_field_name
        this.last_edited_item.query = this.query
      }
      else if(this.selected_report == 'Detailed' || (this.selected_report == 'Hybrid' && this.hybrid_action == 'Detailed'))
        this.confirm_detailed_details.push({ key: this.getFieldKey(this.entered_field_name), backend_heading: this.entered_field_name, value: this.entered_field_name, query: this.query })
      else
        this.confirm_summary_details.push({ key: this.getFieldKey(this.entered_field_name), backend_heading: this.entered_field_name, value: this.entered_field_name, query: this.query, is_query: true, summary_id: this.summary_id++ })
      this.add_new_field_popup = false
    },
    editQuery(item){
      this.add_new_field_popup = true
      this.new_field_status = 'Edit Field'
      this.last_edited_item = item
      this.query = item.query
      this.entered_field_name = item.value
      this.add_field_query_status = 'Start Query'
    },
    globalQuery(){
      if(this.global_query_status == 'Start Query'){
        this.global_query = ''
        this.global_condition = []
        this.global_query_status = 'End Query'
      } else if(this.global_query_status == 'Edit Query'){
        this.global_query_status = 'End Query'
      }else{
        this.global_query_status = 'Edit Query'
      }
    },
    global_query_input(){
      const ind = this.global_query.length - 1
      if(this.global_query[ind] == "'"){
        const manual_entered = this.global_query.slice(0,ind).split(' ').pop()
        if(manual_entered != ''){
          this.global_condition.push(manual_entered)
          this.enter_global_manually = false
        }
      }
    },
    new_field_query_input(){
      const ind = this.query.length - 1
      if(this.query[ind] == "'"){
        const manual_entered = this.query.slice(0,ind).split(' ').pop()
        if(manual_entered != ''){
          this.new_field_condition.push(manual_entered)
          this.enter_field_manually = false
        }
      }
    },
    startDrag(event, field){
      event.dataTransfer.setData("field", JSON.stringify(field.summary_id));
    },
    onDrop(event, target){
      const fieldData = event.dataTransfer.getData("field");
      if (!fieldData) return;

      const field = JSON.parse(fieldData);
      const dragged_data = this.confirm_summary_details.filter(item => item.summary_id == field)
      if(!dragged_data.length) return

      if (target === "rows") {
        this.rowsField = this.rowsField.filter(item=> item.summary_id != dragged_data[0].summary_id);
        this.rowsField.push(dragged_data[0])
      } else if (target === "columns") {
        this.columnsField = this.columnsField.filter(item=> item.summary_id != dragged_data[0].summary_id);
        this.columnsField.push(dragged_data[0])
      }
    },
    removeField(target, index){
      if (target === "rows") {
        this.rowsField.splice(index, 1);
      } else if (target === "columns") {
        this.columnsField.splice(index, 1);
      }
    },
    submitTemplate(){
      const params = {
        'template_name' : this.selected_template,
        'schema_name' : this.selected_schema,
        'report_type' : this.selected_report.toLowerCase(),
        'column_names' : []
      }
      if(this.selected_report != 'Summary'){
        params.selected_columns = []
        params.custom_fields = []
        this.confirm_detailed_details.forEach(detail => {
          if(detail.query){
            params.custom_fields.push({field_name: detail.key, heading: detail.value, query: detail.query})
          } else {
            params.selected_columns.push({field_name: detail.key, heading: detail.value, query: ''})
          }
        })
      }
      if(this.selected_report != 'Detailed'){
        params.summary_rows = []
        params.summary_columns = []
       this.rowsField.forEach(detail => {
          params.summary_rows.push({field_name: detail.key, heading: detail.value, query: detail.query ? detail.query : ''}) 
        })
       this.columnsField.forEach(detail => {
          params.summary_columns.push({field_name: detail.key, heading: detail.value, query: detail.query ? detail.query : ''})
        })
        if(this.rowsField.length + this.columnsField.length < this.confirm_summary_details.length){
          this.$toast.error('Please select all summary fields to either Rows or Columns')
          return
        }
        const un_query_fields = this.columnsField.filter(detail => !detail.query)
        if(un_query_fields.length > 0){
          const field_name = un_query_fields.map(item => item.value).join(', ')
          this.$toast.error(`For summary report, selected column(s) ${field_name} should have query!`)
          return
        }
      }
      params.query_conditions = this.global_query
      this.isLoading = true
      const api = this.template_action == 'Edit Template' && this.clone_key === 'Edit' ? `/api/v2/report_builders/update_report_template?id=${this.$store.state.lotIds.id}` : "/api/v2/report_builders/create_report_template"
      this.$httpSecured
      [this.template_action == 'Edit Template' && this.clone_key === 'Edit' ? 'put' : 'post'](api, params)
      .then(response => {
          this.$store.commit('setMessage', { 
            responseMessage: response.data.message,
            action: ''
          });
          this.isLoading = false
          this.$router.push({ name : 'reportBuilder'});
      })
      .catch(error => {
        this.isLoading = false
        this.$toast.error(error.response.data);
      });
    },
    updateHybridAction(){
      if(this.hybrid_action == 'Detailed'){
        this.selected_details = this.selected_summary_details.map(item => item)
        this.hybrid_action = 'Summary'
      }
      else{
        this.selected_details = this.selected_detailed_details.map(item => item)
        this.hybrid_action = 'Detailed'
      }
    },
    reportTypeChange(){
      this.confirm_detailed_details = []
      this.confirm_summary_details = []
      this.selected_details = []
      this.selected_detailed_details = []
      this.selected_summary_details = [] 
      this.rowsField = []
      this.columnsField = []
      if(this.selected_report == 'Hybrid')
        this.hybrid_action = 'Summary'
    },
    async updateEditdata(){
      const data = this.$store.state.lotIds
      this.selected_schema = data.schema_name,
      this.selected_template = data.template_name
      this.global_query_status = 'Edit Query'
      this.selected_report = data.report_type ? data.report_type[0].toUpperCase() + data.report_type.slice(1) : null
      await this.getItemDetailOptions()
      if(this.selected_report != 'Detailed'){
        data.summary_rows.forEach(item => {
          const obj = {key: item.field_name, backend_heading: this.mapped_key[item.field_name], value: item.heading, query: item.query, is_query: !!item.query, summary_id: this.summary_id++}
          this.rowsField.push(obj)
          this.confirm_summary_details.push(obj)
        })
        data.summary_columns.forEach(item => {
          const obj = {key: item.field_name, backend_heading: this.mapped_key[item.field_name], value: item.heading, query: item.query, is_query: !!item.query, summary_id: this.summary_id++}
          this.columnsField.push(obj)
          this.confirm_summary_details.push(obj)
        })
      }
      if(this.selected_report != 'Summary'){
        data.selected_columns.forEach(item => {
          this.confirm_detailed_details.push({key: item.field_name, backend_heading: this.mapped_key[item.field_name], value: item.heading, query: item.query})
        })
        data.custom_fields.forEach(item => {
          this.confirm_detailed_details.push({key: item.field_name, backend_heading: this.mapped_key[item.field_name], value: item.heading, query: item.query})
        })
      }
      this.selected_detailed_details = this.template_column_list.filter(item => this.confirm_detailed_details.some(detail => detail.key == item.key))
      this.selected_summary_details = this.template_column_list.filter(item => this.confirm_summary_details.some(detail => detail.key == item.key))
      if(this.selected_report != 'Detailed')
        this.selected_details = this.selected_summary_details.map(item => item)
      else this.selected_details = this.selected_detailed_details.map(item => item)
      this.global_query = data.query_conditions
      this.global_condition = data.query_conditions.split(' ').filter(item =>  item != '')
    },
    downloadSample(){
      if(this.template_action != 'Edit Template'){
        this.$toast.error("Please submit first template.")
        return
      }
      const api = `/api/v2/report_builders/download_sample?is_template=true&id=${this.$store.state.lotIds.id}`
      this.isLoading = true
      this.$httpSecured
      .get(api)
      .then(response => {
        const link = document.createElement('a');
        link.href = response.data.url; 
        link.target = '_blank';
        link.download = `${this.$store.state.lotIds.template_name}.csv`; 
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.isLoading = false
      })
      .catch(error => {
        this.isLoading = false
        this.$toast.error(error.response.data.error)
      });
    },
    updateCustomHeading(){
      if(this.add_field_query_status == 'End Query' && this.canAddField()){
        this.query += `${this.selected_field} `
        this.new_field_condition.push(this.selected_field)
      }
      this.selected_field = null
    },
    cancelTemplate(){
      this.reportTypeChange()
    }

  }
}
</script>
<style scoped>
  .sub_heading{
    font-size: 14px;
    font-weight: 600;
    line-height: 16.94px;
    color: #1A1B35;
  }
  .selected_detail_popup{
    border-radius: 8px;
    border: 1px solid #E2E3ED;
  }
  .selected_deatils_option{
    background: #EDEDF8;
    border-radius: 12px;
    padding: 8px;
  }
  .details_option{
    color: #6E7089;
    font-size: 14px;
    font-weight: 600;
    line-height: 19.6px;
    cursor: pointer;
  }
  .chevron_icon{
    position: relative;
    left: 99%;
    top: -50%;
    width: 44px;
    height: 44px;
    border-radius: 22px;
    background: #EDEDF8;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 10;
  }
  .link_css{
    color:#0357D0; 
    font-size: 14px; 
    font-weight: 600px;
    text-decoration: underline;
    cursor: pointer;
  }

.target-areas {
  display: flex;
  height: 100% !important;
}

.area {
  flex: 1;
  /* border: 1px  solid #E2E3ED; */
}

.field {
  padding: 10px;
  margin: 8px 0;
  background-color: #f5f5f5;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: grab;
  transition: all 0.2s;
}

.field:hover {
  background-color: #e9e9e9;
}

.drop-zone {
  height: 250px;
  border: 1px solid #E2E3ED;
  padding: 15px;
  transition: all 0.2s;
  overflow-y: auto;
}

.drop-zone:hover {
  border-color: #999;
}
.operator_btn{
  border: 1px solid #0000001A;
  padding: 10px;
  border-radius: 4px;
  cursor: pointer;
}
</style>